import { createVNode as s, mergeProps as a } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/YasuoTwoTone.js";
import m from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return s(m, a(t, {
    icon: n
  }), null);
};
o.displayName = "YasuoTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
